import React from 'react';
import clsx from 'clsx';
import { btn, btnCart } from './buttons.module.css';

const CartButton = () => {
  return (
    <svg viewBox="0 0 512 512" className={clsx(btn, btnCart)}>
      <g>
        <path
          style={{
            fill: '#E07A5F',
          }}
          d="M451.938,374.154H156.023c-6.878,0-12.844-4.747-14.391-11.448L67.02,39.385H14.769  C6.613,39.385,0,32.772,0,24.616S6.613,9.846,14.769,9.846h64c6.878,0,12.844,4.747,14.391,11.448l74.612,323.321h284.166  c8.157,0,14.769,6.613,14.769,14.769C466.708,367.541,460.095,374.154,451.938,374.154z"
          data-original="#6972DA"
          className="active-path"
          data-old_color="#6972DA"
        />
        <path
          style={{
            fill: '#3FA875',
          }}
          d="M508.764,74.466c-2.803-3.503-7.046-5.542-11.533-5.542H92.402c-4.501,0-8.756,2.052-11.558,5.575  s-3.845,8.13-2.833,12.515l45.444,196.923c1.547,6.701,7.514,11.448,14.391,11.448h315.077c6.908,0,12.893-4.788,14.409-11.527  L511.64,86.935C512.625,82.557,511.567,77.97,508.764,74.466z"
          data-original="#1692FF"
          className=""
          data-old_color="#1692FF"
        />
        <path
          style={{
            fill: '#E07A5F',
          }}
          d="M216.615,393.846c-29.86,0-54.154,24.293-54.154,54.154c0,29.86,24.293,54.154,54.154,54.154  s54.154-24.293,54.154-54.154C270.769,418.14,246.476,393.846,216.615,393.846z"
          data-original="#6972DA"
          className="active-path"
          data-old_color="#6972DA"
        />
        <g>
          <path
            style={{
              fill: '#FFB229',
            }}
            d="M393.846,393.846c-29.86,0-54.154,24.293-54.154,54.154c0,29.86,24.293,54.154,54.154,54.154   c29.86,0,54.154-24.293,54.154-54.154C448,418.14,423.707,393.846,393.846,393.846z"
            data-original="#4F5EC6"
            className=""
            data-old_color="#4F5EC6"
          />
          <path
            style={{
              fill: '#FFB229',
            }}
            d="M451.938,344.616H256v29.538h195.938c8.157,0,14.769-6.613,14.769-14.769   C466.708,351.228,460.095,344.616,451.938,344.616z"
            data-original="#4F5EC6"
            className=""
            data-old_color="#4F5EC6"
          />
        </g>
        <path
          style={{
            fill: '#81B29A',
          }}
          d="M497.231,68.923H256v226.462h196.923c6.908,0,12.893-4.788,14.409-11.527L511.64,86.935  c0.986-4.378-0.073-8.965-2.876-12.469C505.96,70.962,501.718,68.923,497.231,68.923z"
          data-original="#007FDD"
          className=""
          data-old_color="#007FDD"
        />
      </g>
    </svg>
  );
};

export default CartButton;
